import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: active !== "all" ? { category: active } : {} })
      .then((r) => setProducts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [active]);

  const setCategory = (cat) => {
    if (cat === "all") setParams({});
    else setParams({ category: cat });
  };

  return (
    <div className="max-w-[1500px] mx-auto px-5 sm:px-8 py-12">
      <div className="border-b border-border pb-6 mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-accent mb-2">The Store</div>
        <h1 className="font-heading font-black text-4xl sm:text-6xl tracking-tighter uppercase">Shop All</h1>
      </div>

      <div className="flex flex-wrap gap-3 mb-8">
        {["all", ...categories].map((cat) => (
          <button
            key={cat}
            data-testid={`filter-${cat.toLowerCase()}`}
            onClick={() => setCategory(cat)}
            className={`px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] border transition-colors ${active === cat ? "bg-foreground text-background border-foreground" : "border-border hover:border-foreground"}`}
          >
            {cat === "all" ? "All" : cat}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="py-20 text-center font-mono text-sm text-muted-foreground">Loading products…</div>
      ) : products.length === 0 ? (
        <div className="py-20 text-center text-muted-foreground">No products found.</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
